import {IElementWedlet, IWedlet, WEDLET} from "back/edit/wed/wedlets/wedlet";
import {DOMSH} from "lib/commons/xml/domsh";
import {Button} from "back/commons/widgets/buttons";
import {JSX} from "lib/commons/xml/dom";
import {REG} from "lib/commons/registry";
import {REMOTE} from "lib/core/remote";
import {IJmlNode, JML} from "lib/commons/xml/jml";
import {IXmlMsg} from "lib/edit/ot/xmlHouse";
import {LANG} from "lib/commons/lang";
import {BoxInput} from "back/edit/wed/wedlets/box/boxTags";


export class BoxInputUrl extends BoxInput {

	configWedletElt(tpl: Element, wedlet: IWedlet) {
		this.dispatchMode = "blur";
		super.configWedletElt(tpl, wedlet);
	}

	protected _createShadow(tpl: Element) {
		const sr = this.attachShadow(DOMSH.SHADOWDOM_INIT);
		WEDLET.installSkins(tpl, sr, this.wedlet, 'box-input');
		if (tpl.hasChildNodes()) {
			WEDLET.cloneSimpleContent(sr, tpl);
			this.focusableElement = this.shadowRoot.querySelector("input,.input");
		}
		if (!this.focusableElement) this.focusableElement = sr.appendChild(<input type="url"/>);
		if (this.isCaretInput()) this.setAttribute("edit-mode", "caret");
	}
}

window.customElements.define("box-input-url", BoxInputUrl);

/**
 *  Permet le lancement de la vérification d'une URL et l'affichage du statut du rapport.
 */
export class BoxUrlCtrl extends HTMLElement implements IElementWedlet {
	wedlet: IWedlet;

	_oldXmlChars: string;
	_statusMarker: HTMLDivElement;
	_refreshBtn: Button;

	get modeAuto() {return this.getAttribute("refresh-mode") === "auto"}

	clearStatus() {
		this._statusMarker.className = '';
		this._refreshBtn.disabled = !this._oldXmlChars;
	}

	async refreshStatus() {
		if (!this._oldXmlChars) return;
		this._refreshBtn.disabled = true;
		this._statusMarker.className = 'pending';
		this._statusMarker.title = "Validation en cours...";
		const report = await REMOTE.checkUrl(this._oldXmlChars, this.wedlet.wedMgr.reg);
		this._refreshBtn.disabled = false;
		this._statusMarker.className = report.status;
		this._statusMarker.title = report.desc;
	}

	configWedletElt(tpl: Element, wedlet: IWedlet) {
		this.wedlet = wedlet;
		this._refreshBtn = <Button id="refresh" icon="/@skin@/commons/icons/refresh.svg" ui-context="bar" onclick={this.onRefresh}/> as Button;
		this._statusMarker = <div id="status"/> as HTMLDivElement;
		const sr = this.attachShadow(DOMSH.SHADOWDOM_INIT);
		WEDLET.installSkins(tpl, sr, wedlet, this.localName);
		sr.append(this._refreshBtn, this._statusMarker);
	}

	protected onChange() {
		if (this.modeAuto) this.refreshStatus();
		else this.clearStatus();
	}

	refreshBindValue(val: IJmlNode) {
		this._oldXmlChars = JML.jmlNode2value(val) || "";
		this.onChange();
	}

	insertChars(from: number, chars: string, msg: IXmlMsg) {
		this._oldXmlChars = LANG.stringInsert(this._oldXmlChars, from, chars);
		this.onChange();
	}

	deleteChars(from: number, len: number, msg: IXmlMsg) {
		this._oldXmlChars = LANG.stringDelete(this._oldXmlChars, from, len);
		this.onChange();
	}

	replaceChars(chars: string, msg: IXmlMsg) {
		this._oldXmlChars = chars;
		this.onChange();
	}

	onRefresh(this: Button) {
		DOMSH.findHost<BoxUrlCtrl>(this).refreshStatus();
	}
}

REG.reg.registerSkin('box-url-ctrl', 1, /* language=CSS */ `
	:host {
		display: flex;
		min-width: 0;
		min-height: 0;
		align-items: center;
	}

	::slotted(*) {
		flex: 1;
	}

	#refresh {
		padding: 0;
		--icon-size: 1em;
	}

	#status {
		width: 10px;
		height: 10px;
		background-repeat: no-repeat;
	}

	#status.pending {
		background-image: url(/@skin@/edit/wed/urlCtrl/pending.svg);
	}

	#status.ok {
		background-image: url(/@skin@/edit/wed/urlCtrl/ok.svg);
	}

	#status.auth,
	#status.invalid,
	#status.net {
		background-image: url(/@skin@/edit/wed/urlCtrl/warn.svg);
	}

	#status.error {
		background-image: url(/@skin@/edit/wed/urlCtrl/error.svg);
	}
`);

window.customElements.define("box-url-ctrl", BoxUrlCtrl);
